var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6145 100 100 77.6145 100 50C100 22.3855 77.6145 0 50 0C22.3855 0 0 22.3855 0 50C0 77.6145 22.3855 100 50 100Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1397 25.9938L54.8605 42.7397C54.0826 43.8849 55.5735 45.2678 56.6539 44.2954L67.7602 34.6368C68.0627 34.3992 68.4733 34.572 68.4733 35.0042V65.2116C68.4733 65.6222 67.9331 65.8166 67.6954 65.5141L34.1172 25.2808C33.0368 23.9627 31.4811 23.2496 29.7308 23.2496H28.5208C25.4093 23.2496 22.8164 25.8425 22.8164 29.0189V71.5426C22.8164 74.719 25.3877 77.3119 28.5856 77.3119C30.5735 77.3119 32.4318 76.2963 33.5122 74.5461L44.7913 57.8002C45.5692 56.655 44.0783 55.2721 42.9979 56.2444L31.8916 65.8166C31.5891 66.0543 31.1786 65.8814 31.1786 65.4493V35.3067C31.1786 34.8961 31.7187 34.7017 31.9564 35.0042L65.5563 75.2375C66.6366 76.5556 68.2572 77.2903 69.9426 77.2903H71.1526C74.3289 77.2903 76.9219 74.6973 76.9219 71.521V28.9973C76.9219 25.8209 74.3506 23.228 71.1526 23.228C69.0783 23.228 67.22 24.2652 66.1397 25.9938Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/NEAR.83cd07b7bf64c8913bee04989772e51c.svg";
export { ForwardRef as ReactComponent };